import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./App.scss";
import Aos from "aos";
import Home from "./views";
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsOfUse from "./views/TermsOfUse";
import CookieConsent from "react-cookie-consent";
import { Modal } from "antd";
import CookieSettings from "./components/CookieSettings";

function App() {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    Aos.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
    });
  }, []);

  const handleAccept = () => {
    setOpen(false);
    const customAccept = document.getElementById("customAccept");
    if (customAccept) customAccept.click();
  };

  const infoContent = (
    <CookieSettings
      handleClose={() => handleOpenChange(false)}
      handleAccept={handleAccept}
    />
  );

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/terms" element={<TermsOfUse />} />
        </Routes>
        <CookieConsent
          location="bottom"
          buttonText={
            <>
              <span className="arrow"></span>
              <span className="absolute">Accept</span>
            </>
          }
          cookieName="myAwesomeCookieName2"
          style={{
            background: "#1F43DB 0% 0% no-repeat padding-box",
            width: "90%",
            margin: "auto",
            left: "0",
            right: "0",
            top: "10rem!important",
          }}
          buttonClasses={"consent-button"}
          buttonWrapperClasses={
            "relative w-[9.5rem] sm:right-[3rem] right-[-60%] sm:bottom-[0rem] bottom-[1rem]"
          }
          disableButtonStyles={true}
          expires={150}
          buttonId="customAccept"
        >
          <div className="sm:px-[3rem] sm:py-[1rem] flex flex-wrap items-center justify-between">
            <div className="text-white font-medium sm:w-9/12 sm:mb-0 mb-10">
              By clicking Accept, you agree to the storing of cookies on your
              device to enhance site navigation, analyse site usage, and assist in
              our marketing efforts. View our{" "}
              <Link to="/privacy-policy" className="underline font-bold text-white hover:text-accent-500">
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link to="/terms-of-use" className="underline font-bold text-white hover:text-accent-500">
                Terms of Use
              </Link>{" "}
              for more information.
            </div>
            <div
              onClick={() => handleOpenChange(true)}
              className="text-white mr-6 border-b border-b-white cursor-pointer sm:block hidden"
            >
              Preferences
            </div>
            <div
              onClick={() => handleOpenChange(true)}
              className="text-white mr-6 border-b border-b-white cursor-pointer sm:hidden block absolute left-[1rem] bottom-[2rem]"
            >
              Preferences
            </div>
          </div>
        </CookieConsent>
        <Modal
          open={open}
          closable={false}
          footer={null}
          onCancel={() => handleOpenChange(false)}
          className={"cookie-modal"}
          width={520}
        >
          {infoContent}
        </Modal>
      </Router>
    </div>
  );
}

export default App;
